/* Sticky add tto cart */
const stickyBtn = document.querySelector('.product-form__mobile-sticky-button-show');

if (stickyBtn) {
  const observer = new MutationObserver(() => {
    if (stickyBtn.classList.contains('is-visible')) {
      document.body.classList.add('sticky-atc-visible');
    } else {
      document.body.classList.remove('sticky-atc-visible');
    }
  });

  observer.observe(stickyBtn, { attributes: true });
}

/*  Engraving-product-template JS */
function updateCharCount(input) {
  const charNum = input.value.length;
  document.getElementById("charNum").textContent = charNum;

  const previewContainer = document.querySelector(".engraving-text-preview");
  const previewText = document.getElementById("engravingPreviewText");

  if (charNum > 0) {
    previewContainer.style.display = "block";
    previewText.textContent = input.value;
  } else {
    previewContainer.style.display = "none";
    previewText.textContent = "";
  }
}
function setFontStyle(style) {
  const fontInput = document.getElementById("engravingFontStyle");
  const previewText = document.getElementById("engravingPreviewText");
  const buttons = document.querySelectorAll(".style-btn");

  previewText.classList.remove("script-style");
  buttons.forEach((btn) => btn.classList.remove("active"));

  if (style === "script") {
    previewText.classList.add("script-style");
    fontInput.value = "Cursive";
    buttons[1].classList.add("active");
  } else {
    fontInput.value = "Minimal";
    buttons[0].classList.add("active");
  }
}

async function toggleEngraving(showEngraving, btnElement) {
  const engravingBox = document.getElementById("engravingBox");
  const addBtn = document.getElementById("addEngravingBtn");
  const withoutBtn = document.getElementById("withoutEngravingBtn");
  const input = document.getElementById("engravingInput");
  const fontInput = document.getElementById("engravingFontStyle");
  const charCounter = document.getElementById("charNum");
  const previewContainer = document.querySelector(".engraving-text-preview");
  const previewText = document.getElementById("engravingPreviewText");
  const buttons = document.querySelectorAll(".style-btn");
  const errorMsg = document.getElementById("engravingError");
  const fontStyleButtons = document.querySelectorAll(".style-btn");

  const fontStyleHlocate = document.getElementById("font-style");
  const engravingtext1 = document.getElementById("engraving-text1");
  const engravingtext2 = document.getElementById("engraving-text2");
  const engravingtext3 = document.getElementById("engraving-text3");
  const innerlocate = document.getElementById("innerlocate");
  const outerlocate = document.getElementById("outerlocate");

  const container = btnElement?.closest(".engraving-toggle-container");
  const isEngravable = container?.dataset?.engravingEnabled === "true";

  addBtn?.classList.remove("active");
  withoutBtn?.classList.remove("active");

  if (showEngraving && isEngravable) {
    console.log("isEngravable", isEngravable);
    // await addStaticProduct?.();
  }

  if (showEngraving) {
    engravingBox.style.display = "block";
    addBtn?.classList.add("active");
    if (fontStyleButtons.length > 0) {
      fontStyleButtons[0].click();
    }
  } else {
    engravingBox.style.display = "none";
    withoutBtn?.classList.add("active");
    if (fontStyleHlocate) fontStyleHlocate.value = "";
    if (engravingtext1) engravingtext1.value = "";
    if (engravingtext2) engravingtext2.value = "";
    if (engravingtext3) engravingtext3.value = "";
    if (innerlocate) innerlocate.value = "";
    if (outerlocate) outerlocate.value = "";
    if (input) input.value = "";
    if (fontInput) fontInput.value = "";
    charCounter.textContent = "0";
    previewContainer.style.display = "none";
    previewText.textContent = "";
    input.classList.remove("script-style");
    previewText.classList.remove("script-style");
    buttons.forEach((btn) => btn.classList.remove("active"));
    if (errorMsg) errorMsg.style.display = "none";
  }

  document.querySelector(".btn-1")?.classList.toggle("active", showEngraving);
  document.querySelector(".btn-2")?.classList.toggle("active", !showEngraving);
}

/*  End  Engraving-product-template JS */
// Start judge.me js
function processJudgeMeReviews(container = document) {
  const reviews = container.querySelectorAll(".jdgm-rev");

  reviews.forEach(function (review) {
    const rating = review.querySelector(".jdgm-rev__rating");
    const title = review.querySelector(".jdgm-rev__title");
    const content = review.querySelector(".jdgm-rev__content");
    const timestamp = review.querySelector(".jdgm-rev__timestamp");
    const rowRating = review.querySelector(".jdgm-row-rating");

    // 1. Move .jdgm-rev__rating above .jdgm-rev__title
    if (rating && title && rating !== title.previousSibling) {
      title.parentNode.insertBefore(rating, title);
    }

    // 2. Move .jdgm-rev__timestamp below .jdgm-rev__content
    if (timestamp && content && timestamp !== content.nextSibling) {
      content.parentNode.insertBefore(timestamp, content.nextSibling);
    }

    // 3. Mobile-specific layout
    const screenWidth = window.innerWidth;
    if (screenWidth >= 325 && screenWidth <= 768) {
      if (rowRating && content && rowRating !== content.previousSibling) {
        content.parentNode.insertBefore(rowRating, content);
      }

      if (rating && timestamp && !rating.closest(".rating-content")) {
        const wrapper = document.createElement("div");
        wrapper.className = "rating-content";
        rating.parentNode.insertBefore(wrapper, rating);
        wrapper.appendChild(rating);
        wrapper.appendChild(timestamp);
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  processJudgeMeReviews();

  // MutationObserver for dynamic changes
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) {
          if (node.matches(".jdgm-rev") || node.querySelector(".jdgm-rev")) {
            processJudgeMeReviews(node);
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Re-run on resize (for responsive behavior)
  window.addEventListener("resize", () => processJudgeMeReviews());

  // Run on scroll near bottom
  if (!window.location.pathname.includes("/reviews")) return;
  let scrollTimeout;
  window.addEventListener("scroll", () => {
    // Debounce to limit execution
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      processJudgeMeReviews();
    }, 100); // 100ms debounce
  });
  document.addEventListener("click", (e) => {
    const target = e.target.closest(".jdgm-subtab__name");
    if (target) {
      // Delay slightly to allow content to render
      setTimeout(() => {
        processJudgeMeReviews();
      }, 100);
    }
  });
  document.addEventListener("change", (e) => {
    const selectTarget = e.target.closest(".jdgm-sort-dropdown");
    if (selectTarget) {
      // Delay slightly to allow content to render
      setTimeout(() => {
        processJudgeMeReviews();
      }, 100);
    }
  });
});

// End judge.me js

function toggleSubChild(trigger) {
  const content = trigger.nextElementSibling;

  if (content && content.classList.contains("sub-child")) {
    // Use computed style for accurate visibility detection
    const isVisible = window.getComputedStyle(content).display === "block";

    // Toggle display
    content.style.display = isVisible ? "none" : "block";

    // Toggle chevron rotation
    const chevron = trigger.querySelector(".drawer-menu__chevron.top");
    if (chevron) {
      chevron.classList.toggle("rotated", !isVisible);
    }
  }
}

// Ensure default hidden state for sub-menus (also add this in your CSS)
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".sub-child").forEach((el) => {
    el.style.display = "none";
  });


});

// On drawer menu toggler click
document
  .getElementById("DrawerMenuToggler")
  .addEventListener("click", function () {
    console.log("Drawer menu toggler clicked");

    // Optionally open or reset all tier-1 menus here if needed
    // This block below is optional and depends on your UX design
    /*
  document.querySelectorAll('.drawer-menu__menu-item.tier-1').forEach(trigger => {
    toggleSubChild(trigger); // Be careful: toggles all open/closed at once
  });
  */
  });

// Handle clicks on menu items dynamically
document.addEventListener("click", function (event) {
  const trigger = event.target.closest(".drawer-menu__menu-item");
  if (trigger && /tier-\d+/.test(trigger.className)) {
    toggleSubChild(trigger);
  }
});

document.addEventListener("DOMContentLoaded", function () {


const interval = setInterval(() => {
  const el = document.querySelector('.slp_13efdb');

  if (el) {
    const text = el.textContent.trim();

    // Look for "Purchase" in the text
    const index = text.indexOf('Purchase');
    if (index !== -1) {
      // Split dynamically at "Purchase"
      const firstPart = text.substring(0, index).trim();
      const secondPart = text.substring(index).trim();

      // If both parts contain a number (points/amount), assume it's ready
      if (/\d+/.test(firstPart) && /\d+/.test(secondPart)) {
        el.innerHTML = `${firstPart}<br><strong>${secondPart}</strong>`;
        clearInterval(interval); // stop checking once done
      }
    }
  }
}, 100);

  // EG Auto App popup page reload

let addedToCart = false;
let addToCartCount = 0;
let trackingActive = false;
 
document.addEventListener("click", function(event) {
  const reminder = event.target.closest(".aca-reminder-banner-container");
  if (reminder) {
    trackingActive = true;
  }
});

const modalObserver = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1 && node.id === 'aca-modal') {
        console.log('✅ #aca-modal was added to the DOM!');

        attachAcaModalClickHandler(node);
      }
    }
  }
});

modalObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

function attachAcaModalClickHandler(modal) {
  if (modal._listenerAttached) return;
  modal._listenerAttached = true;
  const modelDialog = document.getElementById("aca-modal-container")
  modelDialog.addEventListener('click', function(event) {
    if (!trackingActive) return;

    const button = event.target.closest(".aca-product-button");
    if (button) {
      addedToCart = true;
      addToCartCount++;
      if (addToCartCount >= 3) {
        setTimeout(() => {
          console.log("♻️ Reloading after 3 clicks...");
          location.reload();
        }, 1700);
      }
    }

    const closeBtn = event.target.closest("#aca-close-icon-container, #aca-bottom-close");
    if (closeBtn) {
      if (addedToCart) {
        const modalContainer = document.querySelector("#aca-modal-container");
        if (!modalContainer) {
          location.reload();
        }
      }
    }
  });
}

 function allowOnlyLettersAndNumbers(value) {
  return /^[a-zA-Z0-9]*$/.test(value);
}

// Function to clean input value
function cleanValue(value) {
  return value.replace(/[^a-zA-Z0-9]/g, '');
}
document.querySelectorAll(".letters-only").forEach(input => {

  // ✅ Handle all input methods including mobile emoji
  input.addEventListener("input", function (event) {
    const currentValue = input.value;

    const invalidChars = currentValue.match(/[^a-zA-Z0-9]+/g);

      if (invalidChars) {
        alert(`Please use letters A–Z or 0-9 only`);
      }

    if (!allowOnlyLetters(currentValue)) {
      // Clean the value by removing invalid characters (including emojis)
      const cleanedValue = cleanValue(currentValue);
      input.value = cleanedValue;
    }
  });
  // ✅ Block invalid keystrokes (desktop fallback)
  input.addEventListener("keypress", function (event) {
    if (event.key.length === 1 && !allowOnlyLettersAndNumbers(event.key)) {
      alert("Please use letters A–Z or 0-9 only");
      event.preventDefault();
    }
  });
  // ✅ Prevent invalid paste
  input.addEventListener("paste", function (event) {
    event.preventDefault();
    const pasted = (event.clipboardData || window.clipboardData).getData("text");
    const cleanedPaste = cleanValue(pasted);
    
    if (cleanedPaste !== pasted) {
      alert("Please use letters A–Z or 0-9 only");
    }
    
    // Insert only the valid characters
    if (cleanedPaste) {
      const currentValue = input.value;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const maxLength = input.maxLength;
      
      // Calculate available space
      let textToInsert = cleanedPaste;
      if (maxLength > 0) {
        // Calculate how many characters will remain after removing selected text
        const remainingLength = currentValue.length - (end - start);
        // Calculate how much space is available for new text
        const availableSpace = maxLength - remainingLength;
        textToInsert = cleanedPaste.slice(0, Math.max(0, availableSpace));
      }
      
      // Only proceed if there's text to insert
      if (textToInsert.length > 0) {
        // Use execCommand for better compatibility with character counters
        if (document.execCommand) {
          document.execCommand('insertText', false, textToInsert);
        } else {
          // Fallback: manual insertion with event dispatch
          const newValue = currentValue.slice(0, start) + textToInsert + currentValue.slice(end);
          input.value = newValue;
          const newCursorPos = start + textToInsert.length;
          input.setSelectionRange(newCursorPos, newCursorPos);
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
        
        // Update character count display
        const charNumSpan = document.getElementById('charNum');
        if (charNumSpan) {
          charNumSpan.textContent = input.value.length;
        }
      }
    }
  });
});

function allowOnlyLetters(value) {
  return /^[a-zA-Z]*$/.test(value);
}

function cleanSymbolText() {
  const engravingText = document.querySelector('#engravingPreviewText');
  if (engravingText && !allowOnlyLettersAndNumbers(engravingText.textContent)) {
      engravingText.textContent = cleanValue(engravingText.textContent);
              document.querySelectorAll(".charNum").forEach(num => {
         num.textContent = cleanValue(engravingText.textContent).length
      })
    }

  document.querySelectorAll(".symbol-text p").forEach(p => {
    if (!allowOnlyLettersAndNumbers(p.textContent)) {
      p.textContent = cleanValue(p.textContent);
            document.querySelectorAll(".charNum").forEach(num => {
         num.textContent = cleanValue(p.textContent).length
      })
       document.querySelectorAll(".personalisedCharNum").forEach(num => {
         num.textContent = `${cleanValue(p.textContent).length}/9`
      })
    }
  });
}

// Run once initially
cleanSymbolText();

// If those <p> nodes change dynamically (typing, IME, paste, etc.),
// observe and clean them in real-time
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === "characterData" || mutation.type === "childList") {
      cleanSymbolText();
    }
  });
});

observer.observe(document.body, {
  characterData: true,
  childList: true,
  subtree: true
}); 


  //       document.addEventListener("click", function () {
  // const target = event.target.closest(".pill--outline");
  //  if (target) {
  //        setTimeout(function(){
  //                  const shippingText = document.querySelector(".quick-view__body .shipping-dates") || document.querySelector(".product__info .shipping-dates");
  //        const informationText = document.querySelector(".hide-preorder-shipping");
  //        const informationTextStock = document.querySelector(".product-stock");
  //        const buttonContainer = document.querySelector(".product-form__btn");
  //           const preOrderDateElementshow = document.querySelector('.pre-order-date');
  //        const updateDate = document.querySelector('.updated-date');
  //        const buttonText = document.querySelector('.quick-view__body .product-form__btn') || document.querySelector(".product__info .product-form__btn");
  //          console.log("buttonText",buttonText)
  //          if(buttonText == null) return;
  //        const clonedButton = buttonText.cloneNode(true);
  //  // Remove the unwanted child elements
  //  clonedButton.querySelectorAll('p, div').forEach(el => el.remove());
  //  // Get the remaining visible text content
  //  const textOnly = clonedButton.textContent.trim();
  //          console.log("textOnly2",textOnly)
  //        const hasNegativeStock = false; // Define this based on your stock logic
  //        if (textOnly === "Pre-Order") {
  //          console.log("hhhh")
  //          if (shippingText) {
  //            shippingText.style.setProperty("display", "block", "important");
  //             shippingText.style.setProperty("margin-top", "10px", "important");
  //            updateDate.textContent = preOrderDateElementshow.textContent
  //            console.log("Showed shipping date");
  //          } else {
  //         const targetElement = document.querySelector('.quick-view__body product-form');
  //            console.log("pppp",targetElement)
  //         if (targetElement && !document.querySelector('.quick-view__body product-form .shipping-dates')) {
  //           const newHTML = `
  //             <div class="product-information-tag__content-wrapper product-information-tag__content-wrapper--left-alignment pre-order-product-information-tag__heading shipping-dates">
  //               <div class="product-information-tag__heading caption3">
  //                 <span class="product-information-tag__heading-icon-wrap caption3">
  //                   <img class="product-information-tag__heading-icon lazyautosizes lazyloaded" alt="" width="1" height="1" style="object-position: 50.0% 50.0%;"
  //                     src="//wanderlustandco.com/cdn/shop/files/svgviewer-output.svg?v=1747048006&width=160"
  //                     sizes="24px">
  //                 </span>
  //                 <span class="product-information-tag__heading-title">
  //                   Ship to Malaysia on <span class="updated-date">${preOrderDateElementshow?.textContent || ''}</span>
  //                 </span>
  //               </div>
  //             </div>
  //           `;
  //           targetElement.insertAdjacentHTML('afterend', newHTML);
  //         }
  //          }
  //        } else {
  //          if (shippingText) {
  //            shippingText.style.setProperty("display", "none", "important");
  //            console.log("Hid shipping date");
  //          }
  //        }
  //        },1000)
  //  }
  //    })
});
